// Internal-silo wrapper for the in-house Anomaly Review route
// (/dashboard/accountant/anomalies/:reportId). The shared AccountantAnomalyReview
// page wraps AnomalyReviewContent in the EXTERNAL "Accountant Portal" shell
// (AccountantLayout) — correct for the external /accountant/anomalies route, but
// wrong chrome for an internal accountant seat. This wrapper renders the same
// content in the internal WorkspaceShell instead. The external route and the
// DataTab embed keep using the shared page unchanged.
import RoleDashboardLayout from '../components/RoleDashboardLayout';
import { AnomalyReviewContent } from '../components/accountant/AnomalyReviewContent';

export default function AccountantAnomalyReviewInternal() {
  return (
    <RoleDashboardLayout role="accountant">
      <AnomalyReviewContent />
    </RoleDashboardLayout>
  );
}
